import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdvancedSearchUiExtensionModule } from './extensions/advanced-search-plugin/advanced-search-ui-extension.module';

import SharedProviders_2_0 from './extensions/org-hierarchy-ui/providers';
import SharedProviders_3_0 from './extensions/admin-ui-extensions/providers';
import SharedProviders_4_0 from './extensions/advanced-stock-level/providers';
import SharedProviders_5_0 from './extensions/company-ui/providers';
import SharedProviders_6_0 from './extensions/custom-promotion-ui-extension/providers';
import SharedProviders_7_0 from './extensions/order-csv-download/providers';
import SharedProviders_8_0 from './extensions/delete-orders/provider';
import SharedProviders_9_0 from './extensions/marketing-preferences/providers';
import SharedProviders_10_0 from './extensions/price-calculation/providers';
import SharedProviders_11_0 from './extensions/redirects-ui-extension/redirects-plugin-providers';


@NgModule({
    imports: [CommonModule, AdvancedSearchUiExtensionModule],
    providers: [...SharedProviders_2_0, ...SharedProviders_3_0, ...SharedProviders_4_0, ...SharedProviders_5_0, ...SharedProviders_6_0, ...SharedProviders_7_0, ...SharedProviders_8_0, ...SharedProviders_9_0, ...SharedProviders_10_0, ...SharedProviders_11_0],
})
export class SharedExtensionsModule {}
